import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CartService } from '../../../../shared/services/cart.service';
import { CartItem } from '../../../../shared/interfaces/cart-item';
import { RootService } from '../../../../shared/services/root.service';
import { OffcanvasCartService } from '../../../../shared/services/offcanvas-cart.service';
import { PriceArticoloService } from '../../../../shared/services/custom/price-articolo.service';
import { StoreService } from 'src/app/shared/services/store.service';
import { Livello } from '../../../../../app/shared/interfaces/custom/componibili';
import { ArticoloFull } from 'src/app/shared/interfaces/custom/articolo';
import { AccountService } from 'src/app/shared/services/custom/account.service';
import Swal from 'sweetalert2';

export type DropcartType = 'dropdown' | 'offcanvas';

@Component({
    selector: 'app-header-dropcart',
    templateUrl: './dropcart.component.html',
    styleUrls: ['./dropcart.component.scss']
})
export class DropcartComponent {
    removedItems: CartItem[] = [];

    @Input() type: DropcartType = 'dropdown';

    @Output() closeMenu: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        public state: OffcanvasCartService,
        public cart: CartService,
        public root: RootService,
        public priceArticolo : PriceArticoloService,
        public store : StoreService,
        public account : AccountService,
    ) { }

    remove(item: CartItem): void {
        if (this.removedItems.includes(item)) {
            return;
        }

        this.removedItems.push(item);
        this.cart.remove(item).subscribe({complete: () => this.removedItems = this.removedItems.filter(eachItem => eachItem !== item)});
    }

    close(): void {
        this.state.close();
    }

    getBoxContentDescription(box_levels : Livello[]) {
        let items = [];
        for (let level of box_levels) {
            for (let item of level.items) {
                items.push(item.qta_selezionata + ' × ' + (item.articolo_componente ? item.articolo_componente.descart : item.codice_articolo_componente));
            }
        }
        return items;
    }

    salvaCarrello() {
        this.closeMenu.emit();
        this.cart.salvaCarrello();
    }
}
